import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 60 30",
	...props,
	children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "gb-s",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 0v30h60V0z" })
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "gb-t",
			children: /* @__PURE__ */ _jsx("path", { d: "M30 15h30v15zv15H0zH0V0zV0h30z" })
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#gb-s)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0v30h60V0z",
					fill: "#012169"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0l60 30m0-30L0 30",
					stroke: "#fff",
					strokeWidth: 6
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0l60 30m0-30L0 30",
					clipPath: "url(#gb-t)",
					stroke: "#C8102E",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30 0v30M0 15h60",
					stroke: "#fff",
					strokeWidth: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30 0v30M0 15h60",
					stroke: "#C8102E",
					strokeWidth: 6
				})
			]
		})
	]
});
export default SvgGb;
